import React from 'react'
import style from './style.module.css'
import { Text } from 'snacks-design-system'
export const Content = () => {
  return (
    <div className={style.content}>
      <div className={style.contentHeader}>
        <Text
          size="var(--xds-font-size-20)"
          fontWeight="var(--xds-font-weight-bold)"
        >
          We're excited to get you started as a courier
        </Text>
      </div>
      <div className={style.contentHeader}>
        <Text
          size="var(--xds-font-size-14)"
          className={style.contentHeaderText}
        >
          Just follow these simple steps to be up and running in no time:
        </Text>
      </div>
      <ul className={style.contentList}>
        <li>
          <img
            src="assets/1-24-x-24-sequence@2x.png"
            className={style.contentIcons}
            alt="1"
          />
          <span>
            Download our Courier app from the App Store or Play Store.
          </span>
        </li>
        <li>
          <a
            className={style.contentLinks}
            href="https://apps.apple.com/nl/app/takeaway-com-courier/id1503301744?itsct=apps_box&itscg=30200"
          >
            <img
              className={style.contentImages}
              src="assets/apple-btn-en@2x.png"
              alt="Download on the App Store"
            />
          </a>
          <a
            className={style.contentLinks}
            href="https://play.google.com/store/apps/details?id=com.takeaway.delivered4all&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
          >
            <img
              className={style.contentImages}
              src="assets/google-play-badge@2x.png"
              alt="Get it on Google Play"
            />
          </a>
        </li>
        <li>
          <img
            src="assets/2-24-x-24-sequence@2x.png"
            className={style.contentIcons}
            alt="2"
          />
          <span>Sign up with your email address.</span>
        </li>
        <li>
          <img
            src="assets/3-24-x-24-sequence@2x.png"
            className={style.contentIcons}
            alt="3"
          />
          <span>
            Click <strong> Connect </strong>to accept the invitation from your
            restaurant, or if you don't see it, ask your manager to invite you
            using your email address.
          </span>
        </li>
      </ul>
    </div>
  )
}

export default Content
